import { BOOKING_FILTERS, QUICK_FILTERS_COUNT } from './bookingFilters'

export const deselectOtherCheckboxFilters = {
  pricedUnderContract: false,
  hasHot: false,
  hasRolled: false,
  noAppointmentTime: false,
  unconfirmedAppointment: false,
  hasClaims: false,
  multiDay: false,
  afterHours: false,
  hasOptions: false,
  dropTrailer: false,
  backhaulEligible: false,
  needsTracking: false,
}

export const TENDERED_SHIPMENT_STATUS = ['tendered', 'waterfall_offered', 'alerted', 'reserved']
export const PENDING_SHIPMENT_STATUSES = ['covered', 'offered']
export const ASSIGNED_SHIPMENT_STATUS = ['assigned']
export const ON_HOLD_STATUS = ['on_hold']
export const IN_TRANSIT_STATUSES = [
  'dispatched',
  'arrived_for_pickup',
  'in_transit',
  'arrived_for_delivery',
]
export const SUBMITTED_STATUSES = ['e_submitted', 'submitted', 'quoted']
export const POST_TRANSIT_STATUSES = [
  'truck_ordered_not_used',
  'documents_received',
  'pod_rejected',
  'invoice_sent',
  'delivered',
]
export const ARCHIVED_STATUSES = ['completed', 'canceled']
export const TRACKING_STATUSES = [
  ...PENDING_SHIPMENT_STATUSES,
  ...ASSIGNED_SHIPMENT_STATUS,
  ...IN_TRANSIT_STATUSES,
  ...POST_TRANSIT_STATUSES,
]
export const REDACTED_CARRIER_STATUSES = ['e_submitted', 'submitted', 'quoted', 'canceled']

export enum StatsKeys {
  onHold = 'onHold',
  tendered = 'tendered',
  pending = 'pending',
  assigned = 'assigned',
  inTransit = 'inTransit',
}

export const SUBMITTED_TAB_LABEL = 'Submitted'
export const ON_HOLD_TAB_LABEL = 'On Hold'
export const TENDERED_TAB_LABEL = 'Tendered'
export const PENDING_TAB_LABEL = 'Pending'
export const ASSIGNED_TAB_LABEL = 'Assigned'
export const IN_TRANSIT_TAB_LABEL = 'In Transit'
export const POST_TRANSIT_TAB_LABEL = 'Post Transit'
export const ARCHIVED_TAB_LABEL = 'Archived'

export const SHIPMENT_TABS = [
  {
    label: SUBMITTED_TAB_LABEL,
    count: 0,
    status: SUBMITTED_STATUSES,
    showCount: true,
    statsKey: undefined,
  },
  {
    label: ON_HOLD_TAB_LABEL,
    count: 0,
    status: ON_HOLD_STATUS,
    showCount: true,
    statsKey: StatsKeys.onHold,
  },
  {
    label: TENDERED_TAB_LABEL,
    count: 0,
    status: TENDERED_SHIPMENT_STATUS,
    showCount: true,
    statsKey: StatsKeys.tendered,
  },
  {
    label: PENDING_TAB_LABEL,
    count: 0,
    status: PENDING_SHIPMENT_STATUSES,
    showCount: true,
    statsKey: StatsKeys.pending,
  },
  {
    label: ASSIGNED_TAB_LABEL,
    count: 0,
    status: ASSIGNED_SHIPMENT_STATUS,
    showCount: true,
    statsKey: StatsKeys.assigned,
  },
  {
    label: IN_TRANSIT_TAB_LABEL,
    count: 0,
    status: IN_TRANSIT_STATUSES,
    showCount: true,
    statsKey: StatsKeys.inTransit,
  },
  {
    label: POST_TRANSIT_TAB_LABEL,
    count: 0,
    status: POST_TRANSIT_STATUSES,
    showCount: true,
    statsKey: undefined,
  },
  {
    label: ARCHIVED_TAB_LABEL,
    count: 0,
    status: ARCHIVED_STATUSES,
    showCount: true,
    statsKey: undefined,
  },
]

const shipmentStatParams = (val: string) => ({ stateOptions: val, status: val })
const reservedParams = shipmentStatParams(TENDERED_SHIPMENT_STATUS[1])
const onHoldStatusParams = shipmentStatParams(ON_HOLD_STATUS[0])
const tenderedStatusParams = shipmentStatParams(TENDERED_SHIPMENT_STATUS[0])
const coveredStatusParams = shipmentStatParams(PENDING_SHIPMENT_STATUSES[0])
const offeredStatusParams = shipmentStatParams(PENDING_SHIPMENT_STATUSES[1])
const assignedStatusParams = shipmentStatParams(ASSIGNED_SHIPMENT_STATUS[0])
const inTransitStatusParams = { status: IN_TRANSIT_STATUSES }

const { deliveryDates, pickupDates, range } = BOOKING_FILTERS
const {
  numCovered,
  numDeliveries,
  numHot,
  numNeedsTracking,
  numNoAppt,
  numNoOptions,
  numOffered,
  numPickups,
  numPricedUnderContract,
  numSameDay,
  numUnconfirmedAppt,
  numWaterfall,
} = QUICK_FILTERS_COUNT

const ON_HOLD_STATS = [
  {
    label: 'No Appt',
    key: numNoAppt,
    filters: { ...onHoldStatusParams, ...deselectOtherCheckboxFilters, noAppointmentTime: true },
    stopDate: pickupDates,
  },
  {
    label: 'Unconfirmed',
    key: numUnconfirmedAppt,
    filters: {
      ...onHoldStatusParams,
      ...deselectOtherCheckboxFilters,
      unconfirmedAppointment: true,
    },
    stopDate: pickupDates,
  },
  {
    label: 'Hot',
    key: numHot,
    filters: { ...onHoldStatusParams, ...deselectOtherCheckboxFilters, hasHot: true },
    stopDate: pickupDates,
  },
]

const ON_HOLD_LATER = [
  {
    label: 'No Appt',
    key: numNoAppt,
    filters: { ...onHoldStatusParams, ...deselectOtherCheckboxFilters, noAppointmentTime: true },
    stopDate: range,
  },
  {
    label: 'Unconfirmed',
    key: numUnconfirmedAppt,
    filters: {
      ...onHoldStatusParams,
      ...deselectOtherCheckboxFilters,
      unconfirmedAppointment: true,
    },
    stopDate: range,
  },
  {
    label: 'Hot',
    key: numHot,
    filters: { ...onHoldStatusParams, ...deselectOtherCheckboxFilters, hasHot: true },
    stopDate: range,
  },
]

const TENDERED_STATS = [
  {
    label: 'Tendered',
    key: numPickups,
    filters: { ...tenderedStatusParams, ...deselectOtherCheckboxFilters },
    stopDate: pickupDates,
  },
  {
    label: 'Contract',
    key: numPricedUnderContract,
    filters: {
      ...tenderedStatusParams,
      ...deselectOtherCheckboxFilters,
      pricedUnderContract: true,
    },
    stopDate: pickupDates,
  },
  {
    label: 'Hot',
    key: numHot,
    filters: { ...tenderedStatusParams, ...deselectOtherCheckboxFilters, hasHot: true },
    stopDate: pickupDates,
  },
  {
    label: 'No Options',
    key: numNoOptions,
    filters: { ...tenderedStatusParams, ...deselectOtherCheckboxFilters, hasOptions: true },
    stopDate: pickupDates,
  },
  {
    label: 'Reserved',
    key: numWaterfall,
    filters: { ...reservedParams, ...deselectOtherCheckboxFilters },
    stopDate: pickupDates,
  },
]

const PENDING_STATS = [
  {
    label: 'Covered',
    key: numCovered,
    filters: { ...coveredStatusParams, ...deselectOtherCheckboxFilters },
    stopDate: pickupDates,
  },
  {
    label: 'Offered',
    key: numOffered,
    filters: { ...offeredStatusParams, ...deselectOtherCheckboxFilters },
    stopDate: pickupDates,
  },
]

const PENDING_STATS_LATER = [
  {
    label: 'Covered',
    key: 'numCovered',
    filters: { ...coveredStatusParams, ...deselectOtherCheckboxFilters },
    stopDate: range,
  },
  {
    label: 'Offered',
    key: 'numOffered',
    filters: { ...offeredStatusParams, ...deselectOtherCheckboxFilters },
    stopDate: range,
  },
]

const ASSIGNED_STATS_TODAY = [
  {
    label: 'Picking Up',
    key: numPickups,
    filters: { ...assignedStatusParams, ...deselectOtherCheckboxFilters },
    stopDate: pickupDates,
  },
  {
    label: 'Delivering',
    key: numDeliveries,
    filters: { ...assignedStatusParams, ...deselectOtherCheckboxFilters },
    stopDate: deliveryDates,
  },
  {
    label: 'Needs Tracking',
    key: numNeedsTracking,
    filters: { ...assignedStatusParams, ...deselectOtherCheckboxFilters, needsTracking: true },
    stopDate: pickupDates,
  },
  {
    label: 'Same Day',
    key: numSameDay,
    filters: { ...assignedStatusParams, ...deselectOtherCheckboxFilters },
    stopDate: 'sameDay',
  },
  {
    label: 'Hot',
    key: numHot,
    filters: { ...assignedStatusParams, ...deselectOtherCheckboxFilters, hasHot: true },
    stopDate: pickupDates,
  },
]
const ASSIGNED_STATS_TOMORROW = [
  {
    label: 'Picking Up',
    key: numPickups,
    filters: { ...assignedStatusParams, ...deselectOtherCheckboxFilters },
    stopDate: pickupDates,
  },
  {
    label: 'Delivering',
    key: numDeliveries,
    filters: { ...assignedStatusParams, ...deselectOtherCheckboxFilters },
    stopDate: deliveryDates,
  },
  {
    label: 'Needs Tracking',
    key: numNeedsTracking,
    filters: { ...assignedStatusParams, ...deselectOtherCheckboxFilters, needsTracking: true },
    stopDate: pickupDates,
  },
]

const IN_TRANSIT_TOMORROW = [
  {
    label: 'Picking Up',
    key: numPickups,
    filters: { ...inTransitStatusParams, ...deselectOtherCheckboxFilters },
    stopDate: pickupDates,
  },
  {
    label: 'Delivering',
    key: numDeliveries,
    filters: { ...inTransitStatusParams, ...deselectOtherCheckboxFilters },
    stopDate: deliveryDates,
  },
]

const IN_TRANSIT_TODAY = [
  {
    label: 'Picking Up',
    key: numPickups,
    filters: { ...inTransitStatusParams, ...deselectOtherCheckboxFilters },
    stopDate: pickupDates,
  },
  {
    label: 'Delivering',
    key: numDeliveries,
    filters: { ...inTransitStatusParams, ...deselectOtherCheckboxFilters },
    stopDate: deliveryDates,
  },
  {
    label: 'Same Day',
    key: numSameDay,
    filters: { ...inTransitStatusParams, ...deselectOtherCheckboxFilters },
    stopDate: 'sameDay',
  },
  {
    label: 'Hot',
    key: numHot,
    filters: { ...inTransitStatusParams, ...deselectOtherCheckboxFilters, hasHot: true },
    stopDate: pickupDates,
  },
]

export enum TimeStats {
  today = 'today',
  tomorrow = 'tomorrow',
  later = 'later',
}

export const SHIPMENT_STATS_MAP = {
  [StatsKeys.onHold]: {
    [TimeStats.today]: ON_HOLD_STATS,
    [TimeStats.tomorrow]: ON_HOLD_STATS,
    [TimeStats.later]: ON_HOLD_LATER,
  },
  [StatsKeys.tendered]: {
    [TimeStats.today]: TENDERED_STATS,
    [TimeStats.tomorrow]: TENDERED_STATS,
    [TimeStats.later]: undefined,
  },
  [StatsKeys.pending]: {
    [TimeStats.today]: PENDING_STATS,
    [TimeStats.tomorrow]: PENDING_STATS,
    [TimeStats.later]: PENDING_STATS_LATER,
  },
  [StatsKeys.assigned]: {
    [TimeStats.today]: ASSIGNED_STATS_TODAY,
    [TimeStats.tomorrow]: ASSIGNED_STATS_TOMORROW,
    [TimeStats.later]: undefined,
  },
  [StatsKeys.inTransit]: {
    [TimeStats.today]: IN_TRANSIT_TODAY,
    [TimeStats.tomorrow]: IN_TRANSIT_TOMORROW,
    [TimeStats.later]: undefined,
  },
}

export const SCHEDULER_NAME = 'scheduler'

// TODO: Remove these once files are converted to TS
export const TOMORROW_STATS = TimeStats.tomorrow
export const TODAY_STATS = TimeStats.today
export const LATER_STATS = TimeStats.later
